import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  myRedemptionList: [],
};

const memberMyRedemptionSlice = createSlice({
  name: "memberMyRedemption",
  initialState,
  reducers: {
    setMyRedemptionList: (state, action) => {
      state.myRedemptionList = action.payload;
    },
    clearMyRedemptionList: (state) => {
      state.myRedemptionList = [];
    },
  },
});

export const {
  setMyRedemptionList,
  clearMyRedemptionList,
} = memberMyRedemptionSlice.actions;
export default memberMyRedemptionSlice.reducer;
